import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { DonutChart } from '../../../../component';
const ProfileGradeComponent = ({ containerclass }) => {
  return (
    <div
      className={`h-100 d-flex flex-column justify-content-start align-items-start bg-white border default-border-radius-small ${containerclass}`}
    >
      <div className="d-flex flex-column align-items-start pb-3 pt-4 px-4 font-normal">
        <FormattedMessage id="profile.donutChart" />
      </div>
      <div className="d-flex flex-column align-items-center w-100 h-100">
        <DonutChart />
      </div>
    </div>
  );
};
ProfileGradeComponent.propTypes = {
  purchasedList: PropTypes.object,
  totalPoints: PropTypes.number,
  profileGrade: PropTypes.object,
  language: PropTypes.object,
};
ProfileGradeComponent.defaultProps = {
  purchasedList: {},
  totalPoints: 0,
  profileGrade: {},
  language: {},
};

export default injectIntl(ProfileGradeComponent);
